import { useNavigate } from 'react-router-dom';
import { Button, Flex, Text } from '@chakra-ui/react';
import { isPast } from 'date-fns';
import Lottie from 'lottie-react';
import { ROUTES } from '@/routes/Routes';
import PageLayout from '@/ui/Layout/PageLayout';
import animationData from './meetingNotStartedAnimation.lottie.json';

type Props = {
  openDate: Date;
};

function MeetingNotStartedView({ openDate }: Props) {
  const navigate = useNavigate();
  return (
    <PageLayout>
      <Flex
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
        flexDir="column"
        gap={16}
      >
        <Lottie
          animationData={animationData}
          data-test="image-loading-animation"
          loop={true}
          style={{
            width: '25%',
            height: '25%',
          }}
        />
        <Flex flexDir="column" width="100%" alignItems="center" justifyContent="center">
          <Text fontSize="20px" variant="purpleTitleBold">
            This meeting has not started yet
          </Text>
          {!isPast(openDate) ? (
            <>
              <Text variant="graySubTitle" marginBottom="10px">
                It will start{' '}
                {openDate.toLocaleDateString('en-US', {
                  weekday: 'long',
                  day: 'numeric',
                  month: 'long',
                })}
              </Text>
              <Button onClick={() => navigate(ROUTES.HOME)} variant="primary">
                Home
              </Button>
            </>
          ) : null}
        </Flex>
      </Flex>
    </PageLayout>
  );
}

export default MeetingNotStartedView;
